module.exports = __webpack_public_path__ + "img/va.vacf6a492.svg";